import { SocialExportDashboardItems } from '@app/modules/social-export/components/common/SocialExportDashboardItems';
import { Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { AdminSection } from '../Section';

export function SocialIntegrationsSection() {
  return (
    <AdminSection
      title={
        <FormattedMessage
          id="admin.dashboard.socialIntegrationsTitle"
          defaultMessage="Integración con plataformas"
        />
      }
    >
      <Grid container spacing={2}>
        <SocialExportDashboardItems />
      </Grid>
    </AdminSection>
  );
}
